import { useFlagOnaAIEnabled } from "@/hooks/use-flag";

export const useDefaultRedirect = () => {
    const { value: onaEnabled, loading: isLoadingOnaAIEnabled } = useFlagOnaAIEnabled();

    if (isLoadingOnaAIEnabled) {
        return null;
    }

    if (onaEnabled) {
        return "/ai";
    }

    return "/projects";
};
